import { request } from "../_helpers/Auth";

const namespace = "/api";

export const getFicheEmploye = (_id) => {
    return request({
        url: namespace + "/fiche-employe/pdf/" + _id,
        method: "get",
        responseType: "blob", // clé pour que ce soit traité comme un fichier
    });
};
